import { TargetIcon, PersonSimpleRunIcon, type Icon as PhosphorIcon } from '@phosphor-icons/react';
import {
    Brain,
    Mountain,
    Watch,
    BarChart3,
    FileText,
    TrendingUp,
    type LucideIcon,
    HeartPulse,
    BicepsFlexed,
    ShieldUser,
    Anvil,
    BrainCog,
    Shapes,
    Boxes,
    WavesLadder,
    Award,
    Crosshair,
    Gauge,
    Radius,
} from 'lucide-react';
import { ModuleCategory, ModuleSubCategory } from '@/apolloClient.types';

// Icon mapping for each groupingKey.
export const moduleIcons: Record<string, LucideIcon | PhosphorIcon> = {
    // Assessment - Cognitive
    sart: BrainCog,
    'visual-rxn': Shapes,
    'spatial-planning': Boxes,

    // Assessment - Psychological
    'self-determination': Anvil,
    ml360: Radius,
    'ml360-self': Radius,
    'ml360-buddy': Radius,
    'ml360-trainer': Radius,
    'team-resilience': ShieldUser,

    // Assessment - Physical
    'cardio-respiratory': HeartPulse,
    'strength-assessment': BicepsFlexed,
    ippt: Award,
    soc: PersonSimpleRunIcon,
    '20km-road-march': Mountain,
    'fin-swim': WavesLadder,
    bmp: Crosshair,
    weight: Gauge,

    // Training - Cognitive
    'concentration-grid': TargetIcon,

    // External Integration
    'polar-watch': Watch,
    vald: BarChart3,

    // Reporting
    'individual-report': FileText,
    'team-resilience-report': TrendingUp,
};

export const getModuleIcon = (groupingKey: string): LucideIcon | PhosphorIcon => {
    return moduleIcons[groupingKey] || Brain; // Default fallback
};

export const getIconBackground = (category: ModuleCategory, subCategory?: ModuleSubCategory): string => {
    // For Assessment and Training modules, use subcategory colors
    if ((category === ModuleCategory.Assessment || category === ModuleCategory.Training) && subCategory) {
        switch (subCategory) {
            case ModuleSubCategory.Cognitive:
                return 'bg-teal-100 text-teal-500';
            case ModuleSubCategory.Psychological:
                return 'bg-blue-100 text-blue-500';
            case ModuleSubCategory.Physical:
                return 'bg-purple-100 text-purple-500';
            default:
                return 'bg-gray-100 text-gray-500';
        }
    }

    // For External Integration and Reporting modules, use category colors
    switch (category) {
        case ModuleCategory.External:
            return 'bg-yellow-100 text-yellow-500';
        case ModuleCategory.Reporting:
            return 'bg-indigo-100 text-indigo-500';
        default:
            return 'bg-gray-100 text-gray-500';
    }
};
